import { ref } from 'vue';
import { useToast } from 'primevue/usetoast';

import { clientsService } from '../utils/api/clientsService';

import { useClientsStore } from '../store/clients';

export function useDeleteClient(getClientId: () => number) {
  const visible = ref(false);
  const isLoading = ref(false);

  const clientsStore = useClientsStore();

  const toast = useToast();

  async function deleteClient() {
    const clientId = getClientId();

    try {
      isLoading.value = true;
      await clientsService.destroyClient(clientId);

      clientsStore.removeClientById(clientId);
    } catch (error) {
      console.log(error);

      toast.add({
        severity: 'error',
        summary: 'Wystąpił błąd podczas usuwania klienta',
        life: 3000,
      });
    } finally {
      visible.value = false;
      isLoading.value = false;
    }
  }

  return {
    visible,
    isLoading,
    deleteClient,
  };
}
